<template>
  <div class="navigations">
    <div class="navigation">
      <el-form inline>
        <el-form-item>
            <el-button class="btn-submit" @click="editColumn" icon="el-icon-plus">新增</el-button>
        </el-form-item>
        <el-form-item class="hello">
          <el-select v-model="departname"  size="" @change="changeCom" :popper-append-to-body="false" >
          <el-option
            v-for="item in depart1"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        </el-form-item>
      </el-form>
    </div>
    <el-table :header-cell-style="{background:'#f5f5f5',color:'rgb(82,82,82)',fontSize:'16px',fontWeight:400}"
              :data="tableData">
      <el-table-column label="姓名" align="center" prop="name"></el-table-column>
      <el-table-column label="手机号码" align="center" prop="username"></el-table-column>
      <el-table-column label="权限组" align="center" prop="role_name"></el-table-column>
      <el-table-column label="状态" align="center" prop="status">
        <template slot-scope="scope">
          {{scope.row.status == 1?'正常':'禁用'}}
        </template>
      </el-table-column>
      <el-table-column label="是否绑定微信" align="center" prop="openid">
        <template slot-scope="scope">
          {{scope.row.openid == null || scope.row.openid == '' || scope.row.openid == 'null' ?'否':'是'}}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" align="center" prop="created_at"></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <div v-if="roleName=='administrator'">
            <span v-if="scope.row.id!=1" class="nav" @click="editColumn(scope.$index,scope.row)"><i
              class="el-icon-bianji"></i>修改</span>
            <span v-if="scope.row.id!=1">|</span>
            <span v-if="scope.row.id!=1" class="nav" @click="delColumn(scope.$index,scope.row)" style="color:red"><i
              class="el-icon-delete"></i>删除</span>
          </div>
          <div v-else>
            <span v-if=" user==scope.row.name" class="nav" @click="editColumn(scope.$index,scope.row)"><i
              class="el-icon-bianji"></i>修改</span>
            <span v-if=" user==scope.row.name">|</span>
            <span v-if=" user==scope.row.name" class="nav" @click="delColumn(scope.$index,scope.row)" style="color:red"><i
              class="el-icon-delete"></i>删除</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div>
      <el-dialog :title="title" :visible.sync="editFormVisible" class="edit-dialog" :close-on-click-modal="false"
                 :close-on-press-escape="false">
        <el-divider class="inst"></el-divider>
        <el-form class="user-form" :model="userForm" :rules="rules" ref="userForm" label-width="80px">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="userForm.name" placeholder="请输入姓名"></el-input>
          </el-form-item>

          <el-form-item label="手机号码" prop="phone">
            <el-input v-model="userForm.phone" maxlength="11" placeholder="请输入手机号码"></el-input>
          </el-form-item>

          <el-form-item label="状态" prop="status">
            <el-select v-model="userForm.status">
              <el-option v-for="(role,index) in statusList" :value="role.value" :label="role.name"
                         :key="index"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="部门" prop="depart">
            <el-select v-model="userForm.depart">
              <el-option v-for="(role,index) in depart" :value="role.id" :label="role.name" :key="index"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="角色" prop="role_ids">
            <el-select v-model="userForm.role_ids">
              <el-option v-for="(role,index) in roleList" :value="role.id" :label="role.name" :key="index"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="btn-submit" type="primary" @click="submitForm('userForm')">确定</el-button>
          <el-button class="btn-cancel" @click="editFormVisible=false">取消</el-button>
          <div style="font-size:2px;color: #cecfd0;margin: 15px 0">注：手机号作为登录账户，默认密码888888</div>
        </div>
      </el-dialog>
    </div>
    <!-- 分页组件 -->
    <Pagination
      v-if="total > 0"
      :currentPage="currentPage"
      :total="total"
      :limit="limit"
      @handleCurrentChange="handleCurrentChange"
    ></Pagination>
  </div>
</template>

<script>
  import Pagination from "../../components/Pagination";
  import {
    getUserList,
    getRoleList,
    getRoleList2,
    addUser,
    editUser,
    delUser,
    getdepts,
    getdepts2
  } from "../../api/setting";

  export default {
    data() {
      return {
        //搜索部门
        departname:'全部数据',
        depart1:[],
        tableData: [],
        title: '新增',
        editFormVisible: false,
        user: localStorage.getItem("name"),
        roleName: localStorage.getItem('roleName'),
        // 分页参数
        currentPage: 1,
        limit: 10,
        total: 0,
        menuList: [],
        roleList: [],
        depart: [],
        statusList: [
          {
            value: 1,
            name: '正常'
          },
          {
            value: 2,
            name: '禁用'
          }
        ],
        userForm: {
          id: '',
          phone: '',
          depart: '',
          status: '',
          name: '',
          role_ids: '',
          password: '888888'
        },
        //  规则验证
        rules: {
          name: [{required: true, message: '请输入姓名', trigger: 'change'}],
          phone: [{required: true, message: '请输入手机号码', trigger: 'change'}],
        }
      };
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
       changeCom(){
         this.getData(this.departname)
    },
      //获取部门列表
      getDepart() {
        let params = {
          token: localStorage.getItem("token"),
          is_all: 1,
        }
        getdepts2(params).then(res => {
          if (res.errno === 0) {
            this.depart = res.data
            var obj={
              name:'全部数据',
              id:''
            }
            this.depart1=res.data
            this.depart1.push(obj)
          } else if (res.errno === 401) {
            this.$store.dispatch("LogOut").then(() => {
              location.reload(); // 为了重新实例化vue-router对象 避免bug
            });
          } else {
            this.$message.error(res.errno);
          }
        })
      },
      //获取角色列表
      getRole() {
        let params = {
          token: localStorage.getItem('token'),
          is_all: 1
        }
        getRoleList2(params).then(res => {
          if (res.errno === 0) {
            this.roleList = res.data.data
          } else if (res.errno === 401) {
            this.$store.dispatch('LogOut').then(() => {
              location.reload() // 为了重新实例化vue-router对象 避免bug
            })
          } else {
            this.$message.error(res.error)
          }
        })
      },
      //获取菜单列表
      getMenuList() {

      },
      //获取列表数据
      getData(dept_id2) {
        let params = {
          token: localStorage.getItem('token'),
          page: this.currentPage,
          dept_id2:dept_id2
        }
        getUserList(params).then(res => {
          if (res.errno === 0) {
            this.tableData = res.data.data
            this.limit = res.data.per_page
            this.total = res.data.total
          } else if (res.errno === 401) {
            this.$store.dispatch('LogOut').then(() => {
              location.reload() // 为了重新实例化vue-router对象 避免bug
            })
          } else {
            this.$message.error(res.error)
          }
        })
      },
      // 编辑或者新增
      editColumn(index, row) {
        this.editFormVisible = true
        if (row == '' || row == undefined) {
          this.title = '新增'
          this.userForm.id = ''
          this.userForm.name = ''
          this.userForm.phone = ''
          this.userForm.depart = ''
          this.userForm.status = 1
          this.userForm.role_ids = ''
          this.userForm.password = '888888'
        } else {
          this.title = '编辑'
          this.userForm.id = row.id
          this.userForm.name = row.name
          this.userForm.phone = row.username
          this.userForm.depart = row.dept_id
          this.userForm.status = row.status
          this.userForm.role_ids = row.role_ids
          // this.userForm.password='888888'
        }
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.userForm.id == '') {
              if (this.userForm.phone == '') {
                this.$message.error('请输入手机号码')
              } else if (this.userForm.phone.length != 11 || this.userForm.phone[0] != 1) {
                this.$message.error('请输入正确的手机号码')
              } else {
                let params = {
                  token: localStorage.getItem('token'),
                  username: this.userForm.phone,
                  password: '888888',
                  name: this.userForm.name,
                  role_ids: this.userForm.role_ids,
                  status: this.userForm.status,
                  dept_id: this.userForm.depart
                }
                addUser(params).then(res => {
                  if (res.errno === 0) {
                    this.$message({
                      type: "success",
                      message: res.data
                    })
                    this.editFormVisible = false
                    this.getData()
                  } else if (res.errno === 401) {
                    this.$store.dispatch('LogOut').then(() => {
                      location.reload() // 为了重新实例化vue-router对象 避免bug
                    })
                  } else {
                    this.$message.error(res.error)
                  }
                })
              }
            } else {
              let params = {
                id: this.userForm.id,
                token: localStorage.getItem('token'),
                username: this.userForm.phone,
                // password:'888888',
                name: this.userForm.name,
                role_ids: this.userForm.role_ids,
                status: this.userForm.status,
                dept_id: this.userForm.depart
              }
              editUser(params).then(res => {
                if (this.userForm.phone.length != 11 || this.userForm.phone[0] != 1) {
                  this.$message.error('请输入正确的手机号码')
                } else {
                  if (res.errno === 0) {
                    this.$message({
                      type: "success",
                      message: res.data
                    })
                    this.editFormVisible = false
                    this.getData()
                  } else if (res.errno === 401) {
                    this.$store.dispatch('LogOut').then(() => {
                      location.reload() // 为了重新实例化vue-router对象 避免bug
                    })
                  } else {
                    this.$message.error(res.error)
                  }
                }
              })
            }
          }
        })
      },
      // 详情
      detailColumn(index, row) {

      },
      //删除
      delColumn(index, row) {
        this.$confirm('确定要删除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {
            id: row.id,
            token: localStorage.getItem('token')
          }
          delUser(params).then(res => {
            if (res.errno === 0) {
              this.$message({
                type: 'success',
                message: res.data
              })
              this.getData()
            } else if (res.errno === 401) {
              this.$store.dispatch('LogOut').then(() => {
                location.reload() // 为了重新实例化vue-router对象 避免bug
              })
            } else {
              this.$message.error(res.error)
            }
          }).catch(err => {
            this.loading = false
            this.$message.error('删除失败,请稍后再试！')
          })
        }).catch(err => {
          this.loading = false
        })
      },
      //翻页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getData()
      },
    },
    mounted() {
      this.getRole()
      this.getDepart()
      this.getMenuList()
      this.getData()
    },
  };
</script>

<style scoped>
  .edit-dialog >>> .el-dialog {
    width: 30%;
  }

  .edit-dialog >>> .el-dialog__body {
    padding: 10px 20px;
  }

  .edit-dialog >>> .el-select {
    width: 100%;
  }

  .dialog-footer {
    text-align: right;
    margin-top: 30px;
  }

  .navigation {
    /* cursor: pointer; */
    margin-bottom: 20px;
  }

  .inst {
    margin-top: 0px;
    margin-bottom: 20px;
  }

  /* .navigations{
      padding: 10px;
    } */
  .nav {
    cursor: pointer;
    color: #2b52e9;
    margin-right: 8px;
  }

  .nav i {
    margin-right: 5px;
    margin-left: 8px;
  }

  .edit-dialog >>> .el-input__inner {
    /* width: 394px; */
    height: 32px;
    font-size: 12px;
    color: #999999;
    border: 1px solid #cccccc;
  }

  .edit-dialog >>> .el-input__inner:hover {
    border: 1px solid #b0bceb;
    font-size: 12px;
  }

  .edit-dialog >>> .el-input__inner:focus {
    border: 1px solid #2b52e9;
    color: #333333;
    font-size: 12px;
  }
  .hello >>>.el-select .el-input__inner {
    text-align: center;
    width: 137px;
}
</style>





// WEBPACK FOOTER //
// src/views/setting/gmanage.vue